import React from 'react';

function AttributeLabel(props) {
    const { title, classNames } = props;
    return (
        <span className={classNames}>{title}</span>
    )
}

export default AttributeLabel